import Title from "antd/lib/typography/Title";
import styled from "styled-components";

export const StyledTitle = styled(Title)`
  margin-top: 0;
  padding-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
